module.exports = __webpack_public_path__ + "static/media/Rectangle.013500e5.png";